import React from 'react';

export default function PauseScreen({ onResume, onRestart, onGoHome, score, coins }) {
  return (
    <div
      className="absolute inset-0 z-30 flex items-center justify-center"
      style={{ background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(6px)' }}
    >
      <div
        className="p-6 rounded-2xl text-center max-w-xs w-full mx-4"
        style={{
          background: 'linear-gradient(135deg, #1a0a2e, #2d1a4e)',
          border: '2px solid rgba(99,102,241,0.5)',
          boxShadow: '0 0 40px rgba(99,102,241,0.3)',
        }}
      >
        <div className="text-4xl mb-3">⏸️</div>
        <h2 className="font-heading font-black text-2xl text-white mb-4">Paused</h2>

        <div className="flex justify-center gap-6 mb-6">
          <div className="text-center">
            <p className="font-data text-xl font-black" style={{ color: '#6366f1' }}>{score?.toLocaleString()}</p>
            <p className="font-caption text-xs" style={{ color: 'rgba(255,255,255,0.5)' }}>Score</p>
          </div>
          <div className="text-center">
            <p className="font-data text-xl font-black" style={{ color: '#f59e0b' }}>{coins}</p>
            <p className="font-caption text-xs" style={{ color: 'rgba(255,255,255,0.5)' }}>Coins</p>
          </div>
        </div>

        <div className="space-y-2">
          <button
            onClick={onResume}
            className="w-full py-3 rounded-xl font-bold text-white transition-all hover:scale-105 active:scale-95"
            style={{ background: 'linear-gradient(135deg, #6366f1, #8b5cf6)' }}
          >
            ▶️ Resume
          </button>
          <button
            onClick={onRestart}
            className="w-full py-3 rounded-xl font-bold text-white transition-all hover:scale-105 active:scale-95"
            style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)' }}
          >
            🔄 Restart
          </button>
          <button
            onClick={onGoHome}
            className="w-full py-3 rounded-xl font-bold transition-all hover:scale-105 active:scale-95"
            style={{ color: 'rgba(255,255,255,0.5)', border: '1px solid rgba(255,255,255,0.1)' }}
          >
            🏠 Main Menu
          </button>
        </div>
      </div>
    </div>
  );
}
